<div *ngFor="let apiReferenceDetailXMLSection of apiReferenceDetailXMLSections">
  <h4 class="mt-3 mb-0">{{ apiReferenceDetailXMLSection.heading }}</h4>
  <div [ngClass]="apiReferenceDetailXMLSection.sectionClass === undefined ? 'body-table' : apiReferenceDetailXMLSection.sectionClass">
    <div *ngIf="!isSubSection && !apiReferenceDetailXMLSection.body.includes(';')" [id]="pageName + '#' + (apiReferenceDetailXMLSection.body.split('|VERRSION|').shift() || '').trim()" class="title">
      <div [id]="apiReferenceDetailXMLSection.title">
        {{ apiReferenceDetailXMLSection.body.split('|VERRSION|').shift() }}
        <a class="tableVersionInfo" *ngIf="apiReferenceDetailXMLSection.body.includes('|VERRSION|')" [href]="apiReferenceDetailXMLSection.body.split('|VERRSION|').pop()">
          <i class="fa fa-info-circle"></i>
          <span [innerHTML]="apiReferenceDetailXMLSection.body.split('|')[2]"></span>
        </a>
      </div>
    </div>
    <div
      *ngIf="!isSubSection && apiReferenceDetailXMLSection.body.includes(';')"
      [id]="pageName + '#' + (apiReferenceDetailXMLSection.body.split(';')[0] || '').trim()"
      class="title"
      [innerHTML]="apiReferenceDetailXMLSection.body.split(';')[1] | mdToHtml"
    ></div>
    <div *ngFor="let xmlData of apiReferenceDetailXMLSection.xmlDataArray">
      <details *ngIf="xmlData.data.includes('<')" class="border p-2">
        <summary class="flex-text">{{ xmlData.title }}</summary>
        <app-prism-xml [xmlData]="xmlData.data"></app-prism-xml>
      </details>
    </div>
    <app-api-reference-details-xml-section [isSubSection]="true" [apiReferenceDetailXMLSections]="apiReferenceDetailXMLSection.subSections || []"></app-api-reference-details-xml-section>

    <div *ngIf="apiReferenceDetailXMLSection.tableSections" class="mrg-top">
      <app-api-reference-table-section [tableSections]="apiReferenceDetailXMLSection.tableSections"></app-api-reference-table-section>
    </div>
  </div>
</div>
